export const DISTRIBUTION_CYCLE_DAYS = 7;
export const MS_PER_DAY = 24 * 60 * 60 * 1000;

// Closed-form: how many full distribution cycles must pass before
// pendingYield clears the per-distribution minimum, given the current
// balance + APY. If the user already meets the minimum at the upcoming
// cycle (N=0), the qualifying date IS the next distribution date.
// Otherwise we push N cycles forward. The card displays the returned
// date as the regular Next Distribution countdown — no visual flag
// distinguishes a projected date from the immediate-next-cycle date.
//
// Returns null when accrual is zero (apy=0 or balance=0) and the user
// can't reach the threshold by accrual alone — caller decides what to
// surface in that edge case.
export function computeQualifyingDistributionDate({
    pendingYield,
    USDvValue,
    yaasApy,
    minYieldPerDistribution,
    nextDistributionDate,
    cycleDays = DISTRIBUTION_CYCLE_DAYS
}: {
    pendingYield: number;
    USDvValue: number;
    yaasApy: number;
    minYieldPerDistribution: number;
    nextDistributionDate: string;
    cycleDays?: number;
}): string | null {
    if (pendingYield >= minYieldPerDistribution) {
        return nextDistributionDate;
    }
    const cycleAccrual = ((USDvValue * (yaasApy / 100)) / 365) * cycleDays;
    if (cycleAccrual <= 0) {
        return null;
    }
    const cyclesNeeded = Math.ceil((minYieldPerDistribution - pendingYield) / cycleAccrual);
    const qualifyingTime = new Date(nextDistributionDate).getTime() + cyclesNeeded * cycleDays * MS_PER_DAY;
    return new Date(qualifyingTime).toISOString();
}
